<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" :class="
      this.$store.state.isRTL ? 'top-0 position-sticky z-index-sticky' : ''
    " v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" textWhite="text-white" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'" id="navbar">
        <ul class="ms-md-auto navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center" v-if="!name">
            <router-link :to="{ name: 'Signin' }" class="px-0 nav-link font-weight-bold text-white">
              <i class="fa fa-user me-sm-2"></i>
              <span class="d-sm-inline d-none">Sign In</span>
            </router-link>
          </li>

          <li class="nav-item dropdown d-flex align-items-center me-4" v-if="name" id="messageMenu">
            <a href="#" class="p-0 nav-link text-white" id="dropdownMenuButton" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="cursor-pointer fa fa-bell text-success" aria-hidden="true" v-if="hasMessages()"></i>
              <span class="badge rounded-pill bg-danger position-absolute top-0 start-100" v-if="hasMessages()">{{ all_messages.length }}</span>
              <i class="cursor-pointer fa fa-bell" aria-hidden="true" v-if="!hasMessages()"></i>
              
            </a>
            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" aria-labelledby="dropdownMenuButton">
              <div class="d-flex justify-content-between">
                <p class="mb-0 fw-bold">Notifications</p>
                <router-link to="/notifications" class="btn btn-link mb-0 small">
                  <span>See All</span>
                </router-link>
              </div>
              <li class="mb-2" v-for="msg in messages" :key="msg">
                <a class="dropdown-item border-radius-md" data-toggle="modal" data-target="#messageModal"
                  @click.prevent="toggleMessageModal(msg)">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">{{ msg.subject }}</span>
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1" aria-hidden="true"></i> {{ msg.created_at }}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>

          <li class="nav-item d-flex align-items-center" v-if="name">
            <router-link to="#" class="px-0 nav-link font-weight-bold text-white">
              <i class="fa fa-user me-sm-2"></i>
              <span class="d-sm-inline d-none">{{name}} - {{ partnerName }}</span>
            </router-link>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" @click="toggleSidebar" class="p-0 nav-link text-white" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="modal fade" id="messageModal" tabindex="-1" role="dialog" aria-labelledby="messageModalLabel"
    aria-hidden="true" v-bind:class="{ show: showMessageModal }">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="messageModalLabel">{{ messageModalData.title }}</h5>
        </div>
        <div class="modal-body">
          <div v-html="messageModalData.body"/>
        </div>
        <div class="modal-footer">
          <a type="button" class="btn btn-secondary" @click="hideMessageModal()">Close</a>
          <a type="button" class="btn btn-primary" @click="readMessage(messageModalData.id)">Mark As Read</a>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
const endpoint = require("../../router/endpoint");

export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
      name: localStorage.getItem('partner_user_name'),
      partnerName: localStorage.getItem('name'),
      messages: [],
      all_messages: [],
      messageModalData: {},
      showMessageModal: false
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },

    hasMessages() {
      return this.all_messages.length > 0;
    },

    toggleMessageModal(msg) {
      this.messageModalData = {
        id: msg.id,
        title: msg.subject,
        body: msg.message
      }
      this.showMessageModal = true;
      const messageModal = document.getElementById('messageModal');
      messageModal.removeAttribute('aria-hidden');
      messageModal.style.display = 'block';
    },

    hideMessageModal() {
      this.showMessageModal = false;
      const messageModal = document.getElementById('messageModal');
      if (messageModal.style.display) {
        messageModal.style.display = '';
      }
      messageModal.setAttribute('aria-hidden', 'true');
    },

    getMessages() {
      if (localStorage.getItem('token')){
          this.axios
            .post(
              endpoint.MESSAGE_LIST,
              {
  
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`
                }
              }
            )
            .then((response) => {
              if (response.data.response_code === "0000") {
                this.all_messages = response.data.data
                if (Array.isArray(response.data.data)) {
                  this.messages = response.data.data.slice(0, 10);  
                } else {
                  this.messages = [];  
                }
              } else {
                if (response.data.response_code !== "4000") {
                  this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                  });
                }
              }
              this.loading = false
            })
            .catch((e) => {
              this.$notify({
                type: 'error',
                title: 'Error',
                text: e.response.data.message,
              });
              this.loading = false
            });
        }
    },

    readMessage(msg_id) {
      this.axios
        .post(
          endpoint.MESSAGE_READ,
          {
            message_id: msg_id
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            if (response.data.data) {
              this.$notify({
                type: 'info',
                title: 'Info',
                text: 'Message had read',
              });  
              this.hideMessageModal();
            } else {
              this.$notify({
                type: 'error',
                title: 'Error',
                text: 'Can not read message',
              });
            }
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message,
          });
          this.loading = false
        });
    }
  },
  components: {
    Breadcrumbs
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  // updated: function () {
  //   alert('Testing Bro!');
  // }
  // mounted: function () {
  //   this.$nextTick(function () {
  //     if (localStorage.getItem("token")) {
  //       setInterval(() => {
  //         this.getMessages();  
  //       }, 5000);
  //     }
      

  //   });
  // }
};
</script>
